var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AvatarCard_1;
import React, { Component } from 'react';
import { Direction, Size, Status } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { bool, color, eventListener, expression, instanceOf, number, oneOf, oneOfType, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { classNames, enumValues, isEnumValid, isValidWidth, resolveColor, trigger } from '@philips-internal/oswald-ui-utils';
import { Avatar } from '../avatar/avatar.js';
import { CardMode, CardType } from '../card/card-constants.js';
import { CardDate } from '../card-date/card-date.js';
import { StampIcon } from '../stamp/stamp-constants.js';
import { Stamp } from '../stamp/stamp.js';
import AvatarCardAPI from './avatar-card-api.js';
import './avatar-card.css';
let AvatarCard = AvatarCard_1 = class AvatarCard extends Component {
    constructor() {
        super(...arguments);
        this.getStamp = () => {
            const { status, stampVisible = AvatarCard_1.defaultProps.stampVisible } = this.props;
            if (!stampVisible) {
                return null;
            }
            const statusColor = this.getStampColor(status);
            const statusIcon = this.getStampIcon(status);
            const statusLabel = this.getStampLabel(status);
            return (React.createElement(Stamp, { color: statusColor, icon: statusIcon, label: statusLabel }));
        };
        this.getCardDate = () => {
            const { date, dateVisible = AvatarCard_1.defaultProps.dateVisible, mode = AvatarCard_1.defaultProps.mode, type = AvatarCard_1.defaultProps.type, } = this.props;
            if (!dateVisible) {
                return null;
            }
            return (React.createElement(CardDate, { date: date, divider: mode === CardMode.WIDE, type: type }));
        };
        this.getAvatar = () => {
            const [direction, size] = this.getPreset();
            const { image, subtitle, subtitleHiddenOnMobile, title } = this.props;
            const sizeBreakpoints = ['gxsm'];
            const directionBreakpoints = ['gxsm'];
            return (React.createElement(Avatar, { direction: direction, directionBreakpoints: directionBreakpoints, image: image, size: size, sizeBreakpoints: sizeBreakpoints, subtitle: subtitle, subtitleHiddenOnMobile: subtitleHiddenOnMobile, title: title }));
        };
        this.getPreset = () => {
            const { mode = AvatarCard_1.defaultProps.mode } = this.props;
            return mode === CardMode.WIDE
                ? [Direction.HORIZONTAL, Size.MEDIUM]
                : [Direction.VERTICAL, Size.LARGE];
        };
        this.getRootContainerClasses = () => {
            const { className, dateVisible = AvatarCard_1.defaultProps.dateVisible, mode = AvatarCard_1.defaultProps.mode, status, type = AvatarCard_1.defaultProps.type, width = AvatarCard_1.defaultProps.width, } = this.props;
            const rootContainerClasses = {
                'c-avatar-card': true,
                'c-avatar-card--no-date': !dateVisible,
                [`u-grid-col-${width}`]: isValidWidth(width),
                [`c-avatar-card--${type}`]: type === CardType.FEATURED,
                [`c-avatar-card--${mode}`]: mode === CardMode.WIDE,
                [`is-${status}`]: isEnumValid(Status, status),
                [`${className}`]: Boolean(className),
            };
            return classNames(rootContainerClasses);
        };
    }
    getStampIcon(status) {
        switch (status) {
            case Status.APPROVED:
            case Status.AVAILABLE:
            case Status.CONFIRMED:
            case Status.DONE:
            case Status.READY:
                return StampIcon.CHECK;
            case Status.NOT_APPROVED:
                return StampIcon.WARNING;
            case Status.CANCELED:
                return StampIcon.CANCELED;
            case Status.MISSED:
                return StampIcon.CANCELED_OUTLINE;
            case Status.AWAITING_APPROVAL:
            case Status.PROCESSING:
            case Status.WAITING:
                return StampIcon.CLOCK;
            default:
                return this.props.stampIcon;
        }
    }
    getStampColor(status) {
        switch (status) {
            case Status.CONFIRMED:
            case Status.AVAILABLE:
                return 'safety-green';
            case Status.NOT_APPROVED:
                return 'safety-orange';
            case Status.CANCELED:
                return 'safety-red';
            case Status.DONE:
            case Status.MISSED:
            case Status.READY:
            case Status.APPROVED:
            case Status.WAITING:
            case Status.PROCESSING:
            case Status.AWAITING_APPROVAL:
                return 'signal-gray-30';
            default:
                return this.props.color;
        }
    }
    getStampLabel(status) {
        const exps = {
            [Status.NONE]: 'tws.status.done',
            [Status.DONE]: 'tws.status.done',
            [Status.READY]: 'tws.status.ready',
            [Status.MISSED]: 'tws.status.missed',
            [Status.WAITING]: 'tws.status.awaitingapproval',
            [Status.APPROVED]: 'tws.status.approved',
            [Status.CANCELED]: 'tws.status.canceled',
            [Status.AVAILABLE]: 'tws.status.available',
            [Status.CONFIRMED]: 'tws.status.confirmed',
            [Status.PROCESSING]: 'tws.status.processing',
            [Status.NOT_APPROVED]: 'tws.status.notapproved',
            [Status.AWAITING_APPROVAL]: 'tws.status.awaitingapproval',
        };
        return exps[status] || '';
    }
    render() {
        const { color, label, onClick, onDoubleClick, onContextMenuClick } = this.props;
        return (React.createElement("div", { className: this.getRootContainerClasses(), onClick: trigger(onClick, new ClickEvent()), onContextMenu: trigger(onContextMenuClick, new ClickEvent()), onDoubleClick: trigger(onDoubleClick, new ClickEvent()), style: resolveColor(color), "x-contrast": "cl bd" },
            label && React.createElement("span", { className: "c-avatar-card__label u-hide@gxsm" }, MessageService.translate(label)),
            React.createElement("div", { className: "c-avatar-card__wrapper" },
                React.createElement("div", { className: "c-avatar-card__date" }, this.getCardDate()),
                React.createElement("div", { className: "c-avatar-card__avatar" }, this.getAvatar()),
                React.createElement("div", { className: "c-avatar-card__stamp" }, this.getStamp()))));
    }
};
AvatarCard.propTypes = {
    className: string.notEnumerable(),
    color: color,
    date: oneOfType([string, instanceOf(Date)]),
    dateVisible: bool,
    image: string,
    label: expression,
    mode: oneOf(enumValues(CardMode)),
    onClick: eventListener,
    onContextMenuClick: eventListener,
    onDoubleClick: eventListener,
    stampIcon: oneOf(enumValues(StampIcon)),
    stampLabel: expression,
    stampVisible: bool,
    status: oneOf(enumValues(Status)),
    subtitle: expression,
    subtitleHiddenOnMobile: bool,
    title: expression,
    type: oneOf(enumValues(CardType)),
    width: number,
};
AvatarCard.defaultProps = {
    color: '',
    dateVisible: true,
    mode: CardMode.DEFAULT,
    stampVisible: true,
    subtitleHiddenOnMobile: false,
    type: CardType.DEFAULT,
    width: 3,
};
AvatarCard = AvatarCard_1 = __decorate([
    AwesomeComponent({ api: AvatarCardAPI, type: ComponentType.DATA_DISPLAY })
], AvatarCard);
export default AvatarCard;
//# sourceMappingURL=avatar-card.js.map